import { addTranslateHotkey } from './translate.hotkey';
import { TranslateProvider } from './translate.provider';
import { translateConfig } from './translate.config';
import { TranslateDirective, autofocus } from './translate.directive';
import { TranslateModalService } from './modal/translateModal.service';
import { TranslateModalProvider } from './modal/translateModal.provider';
import uibModal from 'angular-ui-bootstrap/src/modal';
import 'angular-hotkeys';

export default angular
  .module('ng1-translate', [uibModal, 'cfp.hotkeys'])
  .directive('autofocus', autofocus)
  .directive('translate', TranslateDirective)
  .service('translateModalService', TranslateModalService)
  .provider('fdTranslate', TranslateProvider)
  .provider('fdTranslateModal', TranslateModalProvider)
  .config(translateConfig)
  .run(addTranslateHotkey)
  .value('translateConfig', {
    apiUrl: 'http://localhost:8080/api/translate'
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-translate/src/index.js